export const RemoteWidgetHandlerClassSymbol = Symbol('RemoteWidgetHandlerClass');
